import api from 'api'
import { Campaign } from 'types/campaign'
import { store } from 'store'
import { campaignFormActions } from '../../../store/campaign-form-slice'
import { CardStatus } from '../../../../../components/Layout/Card'

export default class CampaignCreationsService {
  static updateCampaignCreations = (
    campaignId: Campaign['id'],
    creationContributionType: Campaign['creationContributionType']
  ): Promise<void> => {
    store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.LOADING }))

    return api.campaign
      .updateCampaignCreations(campaignId, creationContributionType)
      .then(response => {
        if (response.errors && response.errors.length > 0) {
          return
        }

        store.dispatch(campaignFormActions.setCreationContributionType(creationContributionType))
        store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.SAVED }))
      })
      .catch(() => {
        store.dispatch(campaignFormActions.setCardStatus({ creations: CardStatus.ERROR }))
      })
  }
}
